// extracted by mini-css-extract-plugin
module.exports = {"marker-img":"styles_marker-img__1sO-o","markerImg":"styles_marker-img__1sO-o"};